import { render, staticRenderFns } from "./PremiumMarketDetail.vue?vue&type=template&id=28188169&scoped=true"
import script from "./PremiumMarketDetail.vue?vue&type=script&lang=js"
export * from "./PremiumMarketDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28188169",
  null
  
)

export default component.exports